import ReactEcharts from "echarts-for-react";
import styled from "styled-components";

/* ─── Shared chart page layout ─── */

export const PageWrapper = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f5;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1.4rem;
  padding: 1.6rem 1.8rem;
  background-color: #3439a5;
  color: #fff;
  font-size: 2rem;
  font-weight: 600;
  cursor: pointer;
  user-select: none;

  svg {
    flex-shrink: 0;
    box-sizing: content-box;
    width: 2.2rem;
    height: 2.2rem;
    padding: 0.8rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.16);
    transition: background 0.15s, transform 0.15s;
    cursor: pointer;
  }

  &:hover svg {
    background: rgba(255, 255, 255, 0.3);
    transform: translateX(-2px);
  }

  &:active svg {
    transform: translateX(-2px) scale(0.94);
  }

  @media (min-width: 768px) {
    padding: 1.8rem 3.2rem;
    font-size: 2.2rem;
  }
`;

export const PageContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.6rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    padding: 2.4rem 3.2rem;
    gap: 2.4rem;
  }
`;

export const FiltersPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid #c0c0c9;
  border-radius: 1rem;
  padding: 1.6rem;

  @media (min-width: 768px) {
    width: 300px;
    flex-shrink: 0;
    position: sticky;
    top: 2.4rem;
  }
`;

export const ChartPanel = styled.div`
  flex: 1;
  background: #fff;
  border: 1px solid #c0c0c9;
  border-radius: 1rem;
  padding: 1.6rem;
  min-height: 360px;

  @media (min-width: 768px) {
    min-height: 480px;
    padding: 2rem;
  }
`;

/* ─── Legacy (kept for compatibility) ─── */

export const Card = styled.div`
  position: relative;
  padding: 1.6rem 0.8rem;
  border-radius: 0.8rem;
`;

export const Chart = styled(ReactEcharts)`
  width: 100% !important;
  height: 100% !important;
  min-height: 320px;
  top: 0;
`;
